import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children, roles }) {
  const { user, loading, role } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center"
        data-testid="protected-loading"
      >
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600" />
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname }}
        data-testid="protected-redirect"
      />
    );
  }

  const normalizedRole = role || user?.user_metadata?.role || null;

  if (roles && roles.length > 0 && !roles.includes(normalizedRole)) {
    // User is logged in but does not have access to this route
    return (
      <Navigate
        to="/access-denied"
        replace
        state={{
          from: location.pathname,
          required: roles,
          role: normalizedRole,
        }}
      />
    );
  }

  return children;
}
